<template>
  <div class="comp-order fit-height">
    <div v-if="ORDER">
      <div class="order-head details-head">
        <div class="inn">
          <div class="info">
            <ul class="meta">
              <li>Order #{{ ORDER.order_number }}</li>
              <li>
                <div class="dropdown">
                  <a href="javascript:;" class="status dropdown-toggle" :class="status" data-toggle="dropdown"
                     @click="showStatusDropdown = !showStatusDropdown">{{ status | statusToUCWords}}</a>
                  <div class="dropdown-menu" :class="{show: showStatusDropdown == true}">
                    <a class="dropdown-item" href="javascript:;" @click="updateStatus(jstatus)"
                       v-for="jstatus in orderStatuses" :key="jstatus" :value="jstatus">
                      {{ jstatus | statusToUCWords }}
                    </a>
                  </div>
                </div>
              </li>
            </ul>
            <div class="title">
              <template v-if="editOrderName">
                <form method="post" action="" @submit.prevent="updateName">
                  <input type="text" class="form-control" v-model="newOrderName" ref="inputName" @blur="updateName">
                </form>
              </template>
              <template v-else>
                <span>{{ ORDER.name }}</span>
                <a href="javascript:;" class="edit icon-pencil"
                   @click="editOrderName = true"></a>
              </template>
            </div>
          </div>
          <div class="btns">
            <button type="button" class="btn btn-outline-gray w150" @click="confDuplicate">Duplicate</button>&nbsp;
            <button type="button" class="btn btn-outline-black w150" @click="downloadPDF">Download</button>
          </div>
        </div>
      </div>
      <div class="auto-height">
        <ul class="order-details">
          <li>
            <div class="form-row">
              <label class="lb">CREATED</label>
              <div class="inputs">
                <div type="text" class="form-control">{{ ORDER.created_at | toHumanDate }} by {{ ORDER.creator.full_name
                  }}
                </div>
              </div>
            </div>
            <div class="form-row">
              <label class="lb">PURCHASE ORDER NO</label>
              <div class="inputs">
                <input type="text" class="form-control" v-model="postData.purchase_order_no">
              </div>
            </div>
            <div class="form-row">
              <label class="lb">
                RELATED JOB
                <template v-if="postData.job_id">
                  <br/>
                  <router-link target="_blank" :to="{ name: 'job', params: { jobId: postData.job_id } }">Go to job</router-link>
                </template>
              </label>
              <div class="inputs">
                <v-select v-model="postData.job_id" :options="allJobs" class="form-control" :reduce="item => item.id"
                          label="name" :searchable="true" :placeholder="'- Select job'"></v-select>
              </div>
            </div>
            <div class="form-row">
              <label class="lb">DELIVERY TO</label>
              <div class="inputs">
                <input class="form-control" v-model="postData.delivery_to" />
              </div>
            </div>
            <div class="form-row">
              <label class="lb">SPECIAL INSTRUCTIONS</label>
              <div class="inputs">
                <textarea class="form-control" v-model="postData.special_instructions"></textarea>
              </div>
            </div>
          </li>
          <li>
            <div class="form-row">
              <label class="lb">SUPPLIER</label>
              <div class="inputs">
                <v-select v-model="postData.supplier_id" :options="allSuppliers" class="form-control"
                          :reduce="item => item.id"
                          label="name" :searchable="true" :placeholder="'- Select supplier'"></v-select>
              </div>
            </div>
            <div class="form-row">
              <label class="lb">COMPANY</label>
              <div class="inputs">
                <v-select v-model="postData.client_id" :options="allClients" class="form-control"
                          :reduce="item => item.id"
                          label="name" :searchable="true" :clearable="false"></v-select>
              </div>
            </div>
            <div class="form-row">
              <label class="lb">CONTACT</label>
              <div class="inputs">
                <v-select v-model="postData.contact_id" :options="clientContacts" class="form-control"
                          :reduce="item => item.id"
                          label="full_name" :searchable="true" :clearable="true"
                          :placeholder="'- Select contact'"></v-select>
              </div>
            </div>
            <div class="form-row">
              <label class="lb">REQUIRED BY</label>
              <div class="inputs">
                <input class="form-control" v-model="postData.required_by" />
              </div>
            </div>
          </li>
          <li>
            <div class="form-row">
              <label class="lb">SUPPLIER QUOTE NO</label>
              <div class="inputs">
                <input type="text" class="form-control" v-model="postData.supplier_quote_no">
              </div>
            </div>
            <div class="form-row">
              <label class="lb">SUPPLIER INVOICE PO</label>
              <div class="inputs">
                <input type="text" class="form-control" v-model="postData.supplier_invoice_po">
              </div>
            </div>
            <div class="text-right">
              <beat-loader v-if="state == 'saving'"></beat-loader>
              <template v-else>
                <button type="button" class="btn btn btn-primary w180" @click="saveOrder(null)">Save</button>
              </template>
            </div>
          </li>
        </ul>
        <div class="order-items">
          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
              <tr>
                <th width="120">CATEGORY</th>
                <th width="140">ITEM</th>
                <th>DETAILS</th>
                <th width="90">QTY/HOURS</th>
                <th width="90">MARKUP</th>
                <th width="90">COST RATE</th>
                <th width="100">COST</th>
                <th width="90">SELL RATE</th>
                <th width="100">SELL</th>
                <th width="70"></th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item, index) in orderItems">
                <order-item-row :item="item" :key="index" :idx="index" @item-saved="onItemSaved" @item-deleted="onItemDeleted"></order-item-row>
              </template>
              <order-item-row v-if="isAdding" idx="-1" @item-saved="onItemSaved" @item-cancelled="onItemCancelled"></order-item-row>
              </tbody>
            </table>
          </div>

          <div class="text-center">
            <button v-if="!isAdding" type="button" class="btn btn-outline-black w180" @click="isAdding = true">Add Item</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import ServiceOrder from '@/services/order'
  import ServiceClient from '@/services/client'
  import ModalDuplicate from './ModalDuplicate';
  import OrderItemRow from './OrderItemRow';

  export default {
    components: {
      BeatLoader,
      OrderItemRow
    },
    data() {
      return {
        state: '',
        status: 'pending',
        updated_dtm: 0,
        editOrderName: false,
        newOrderName: '',
        showStatusDropdown: false,
        orderItems: [],
        showModalEdit: false,
        postData: {
          purchase_order_no: '',
          job_id: '',
          supplier_id: '',
          client_id: '',
          contact_id: '',
          supplier_quote_no: '',
          supplier_invoice_po: '',
          delivery_to: '',
          required_by: '',
          special_instructions: ''
        },
        clientContacts: [],
        isAdding: false
      }
    },
    props: ['orderId'],
    watch: {
      orderId(newVal) {
        if (newVal && this.ORDER && this.ORDER.id != newVal)
          this.init();
      },
      editOrderName(newVal) {
        let self = this;
        if (newVal) {
          self.newOrderName = self.order.name;
          setTimeout(() => {
            self.$refs.inputName.focus();
          }, 200);
        }
      },
      'postData.job_id': function (newVal) {
        if (newVal) {
          let self = this;
          let job = window.getObjectByKeyValue(this.allJobs, 'id', newVal);
          if (job) {
            self.postData.client_id = job.client_id;
          }
        }
      },
      'postData.client_id': function (newVal) {
        this.getContacts(newVal);
      }
    },
    computed: {
      ...mapGetters(['ORDER']),
      ...mapState({
        orderStatuses: state => state.option.orderStatuses,
        allJobs: state => state.option.jobs,
        allClients: state => state.option.clients,
        allSuppliers: state => state.option.suppliers
      })
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let self = this;
        self.showModalEdit = false;
        self.$store.dispatch('GET_ORDER', self.orderId)
          .then(() => {
            self.populateData();
          });
      },
      populateData() {
        let self = this;
        self.status = self.ORDER.status;
        self.orderItems = self.ORDER.items;
        for(let f in self.postData){
          if(typeof self.ORDER[f] != 'undefined')
            self.postData[f] = self.ORDER[f];
        }
        if (self.postData.client_id)
          self.getContacts(self.postData.client_id);
      },
      updateName() {
        let self = this;
        // save to DB
        setTimeout(() => {
          if (self.newOrderName != self.ORDER.name) {
            self.ORDER.name = self.newOrderName;
            self.saveOrder({name: self.newOrderName});
          }
          self.editOrderName = false;
        }, 1000);
      },
      updateStatus(newStatus) {
        let self = this;
        if (newStatus && newStatus != self.status) {
          self.status = newStatus;
          self.saveOrder({status: newStatus});
        }
        self.showStatusDropdown = false;
      },
      saveOrder(updateData) {
        let self = this;
        if (self.state == 'saving') {
          return;
        }
        if (updateData == null) {
          updateData = {};
          Object.assign(updateData, self.postData);
        }

        self.state = 'saving';
        ServiceOrder.save(self.ORDER.id, updateData, order => {
          let now = new Date().getTime();
          if (now - self.updated_dtm > 5 * 1000) {
            self.$notify({
              type: 'success',
              text: 'Order updated'
            });
            self.updated_dtm = now;
          }
          self.state = '';
          self.$store.dispatch('UPDATE_ORDER', order).then(() => {
            self.populateData();
          });
        }, () => {
          self.state = '';
        });
      },
      confDuplicate() {
        let self = this;
        self.$modal.show(ModalDuplicate, {
          order: self.ORDER
        }, {
          clickToClose: false,
          width: 592
        });
      },

      onItemCancelled () {
        this.isAdding = false;
      },
      onItemDeleted (index) {
        let self = this;
        if (typeof self.orderItems[index] != 'undefined') {
          let item = self.orderItems[index];
          self.orderItems.splice(index, 1);
          self.$notify({
            type: 'success',
            text: '<strong>' + item.details + '</strong> item is deleted'
          });
        }
      },
      onItemSaved ( item, index ) {
        let self = this;
        if(index != -1)
          self.orderItems.splice( index, 1, item );
        else
          self.orderItems.push( item );
        self.isAdding = false;
      },
      downloadPDF() {
        let self = this;
        if (self.status == 'processing') {
          return;
        }
        self.state = 'processing';
        ServiceOrder.downloadPDF(self.ORDER.id, resp => {
          self.state = '';
          window.downloadFromBlob(resp.data, 'order_' + self.ORDER.id + '.pdf');
        }, () => {
          self.state = '';
        });
      },
      duplicateItem(index) {
        let self = this;
        self.orderItems.splice(index, 0, self.orderItems[index])
      },
      getContacts(clientId) {
        let self = this;
        ServiceClient.getMembers(clientId, {ipp: 'all'}, resp => {
          self.clientContacts = resp;
        });
      }
    }
  }
</script>
